export default {
  "last24Hours": "Last 24 hours",
  "last7Days": "Last 7 days",
  "last30Days": "Last 30 days",
  "sent": "Sent",
  "date": "Date",
  "recipient": "Recipient",
  "deletedUser": "Deleted user",
  "type": "Type",
  "category": "Category",
  "title": "Title",
  "status": "Status",
  "read": "Read",
  "unread": "Unread",
  "source": "Source",
  "notificationDetails": "Notification details",
  "dismissed": "Dismissed",
  "action": "Action:",
  "opensInNewTab": "(opens in new tab)",
  "closeDetails": "Close details",
  "failedToLoadNotificationHistory": "Failed to load notification history.",
  "failedToDeleteNotifications": "Failed to delete notifications.",
  "deleteAllNotifications": "Delete all notifications",
  "deleteAll": "Delete All",
  "selectAllNotifications": "Select all notifications",
  "deleteNotification": "Delete notification",
  "notificationHistory": "Notification History",
  "refresh": "Refresh",
  "deleteSelectedNotifications": "Delete selected notifications",
  "deleteSelected": "Delete Selected",
  "clearSelection": "Clear Selection",
  "searchNotifications": "Search notifications...",
  "noNotificationsHaveBeenSentYet": "No notifications have been sent yet.",
  "general": "General",
  "system": "System",
  "security": "Security",
  "session": "Session",
  "application": "Application",
  "support": "Support",
  "missingSecurityTokenRefreshThePage": "Missing security token. Refresh the page.",
  "failedToSendNotification": "Failed to send notification.",
  "notificationSent": "Notification sent",
  "sendNotification": "Send Notification",
  "composeAndSendANotificationToUsersTitleAndBody": "Compose and send a notification to users. Title and body support Markdown formatting.",
  "notificationCategory": "Notification category",
  "notificationTitleSupportsMarkdown": "Notification title (supports Markdown)",
  "body": "Body",
  "writeYourNotificationBodyHereSupportsBoldItalicCodeLists": "Write your notification body here... Supports **bold**, *italic*, `code`, lists, and > [!NOTE] callouts.",
  "actionLabel": "Action Label",
  "viewDetails": "View details",
  "optionalButtonText": "Optional button text",
  "actionURL": "Action URL",
  "profileOrHttps": "/profile or https://...",
  "optionalLinkTarget": "Optional link target",
  "reset": "Reset",
  "sending": "Sending...",
  "preview": "Preview",
  "howTheNotificationWillAppearToRecipients": "How the notification will appear to recipients",
  "justNow": "Just now",
  "admin": "Admin",
  "sendNotificationsViaWhatsAppBusinessAPI": "Send notifications via WhatsApp Business API.",
  "all": "All",
  "disabled": "Disabled",
  "failedToLoadTemplate": "Failed to load template",
  "templateSaved": "Template saved",
  "failedToSaveTemplate": "Failed to save template",
  "templateResetToDefault": "Template reset to default",
  "failedToResetTemplate": "Failed to reset template",
  "failedToRenderPreview": "Failed to render preview",
  "notificationTemplates": "Notification Templates",
  "loading": "Loading...",
  "searchTemplates": "Search templates...",
  "noTemplatesFound": "No templates found",
  "noMatches": "No matches",
  "selectATemplateToEdit": "Select a template to edit",
  "chooseAnEntryFromTheListOnTheLeft": "Choose an entry from the list on the left",
  "customized": "Customized",
  "previewTemplate": "Preview template",
  "resetToDefault": "Reset to default",
  "resetTemplateToDefault": "Reset template to default",
  "default": "Default",
  "slug": "slug:",
  "enabled": "Enabled",
  "whenDisabledThisNotificationWillFallBackToTheHardcoded": "When disabled, this notification will fall back to the hardcoded default.",
  "titleTemplate": "Title Template",
  "notificationTitle": "Notification title...",
  "supportsVariablePlaceholders": "Supports {{variable}} placeholders",
  "bodyTemplate": "Body Template",
  "notificationBodyText": "Notification body text...",
  "availableVariables": "Available Variables",
  "rendering": "Rendering...",
  "refreshPreview": "Refresh Preview",
  "generatePreview": "Generate Preview",
  "unsavedChanges": "Unsaved changes",
  "discard": "Discard",
  "saving": "Saving...",
  "save": "Save",
  "recipients": "Recipients",
  "allUsers": "All users",
  "deselectAllUsers": "Deselect all users",
  "searchUsersByNameOrEmail": "Search users by name or email...",
  "searching": "Searching...",
  "loadingDiscordSettings": "Loading Discord settings...",
  "failedToUpdate": "Failed to update",
  "enterAWebhookURLFirst": "Enter a webhook URL first",
  "testMessageSent": "Test message sent",
  "checkYourDiscordChannel": "Check your Discord channel",
  "testFailed": "Test failed",
  "botSettingsSaved": "Bot settings saved",
  "failedToSave": "Failed to save",
  "botTokenVerified": "Bot token verified",
  "botCanSendDMsToUsers": "Bot can send DMs to users.",
  "botTestFailed": "Bot test failed",
  "webhookUsers": "Webhook Users",
  "botDM": "Bot DM",
  "notSet": "Not set",
  "dMUsers": "DM Users",
  "enableDiscordNotifications": "Enable Discord notifications",
  "discordNotificationsAreEnabled": "Discord notifications are enabled",
  "discordNotificationsAreDisabled": "Discord notifications are disabled",
  "sendNotificationsViaDiscordWebhooksOrPrivateBotDMs": "Send notifications via Discord webhooks or private bot DMs.",
  "botTokenDMsCommands": "Bot Token (DMs & commands)",
  "profileNotifications": "Profile > Notifications",
  "botTokenConfiguredHidden": "Bot token configured (hidden)",
  "pasteYourDiscordBotToken": "Paste your Discord bot token",
  "discordBotToken": "Discord bot token",
  "botTokenIsEncryptedAtRestAndNeverExposedIn": "Bot token is encrypted at rest and never exposed in API responses.",
  "enableBotDMDelivery": "Enable bot DM delivery",
  "botDMDeliveryEnabled": "Bot DM delivery enabled",
  "botDMDeliveryDisabled": "Bot DM delivery disabled",
  "serverInviteLink": "Server Invite Link",
  "discordServerInviteLink": "Discord server invite link",
  "shownToUsersSoTheyCanJoinYourDiscordServer": "Shown to users so they can join your Discord server to receive bot DMs.",
  "testToken": "Test Token",
  "botTokenVsWebhook": "Bot token vs. webhook",
  "theseTwoAreNotInterchangeableTheyServeDifferentRoles": "These two are not interchangeable. They serve different roles:",
  "botToken": "Bot token",
  "twoWay": "Two-way",
  "and": "and",
  "webhook2": "Webhook",
  "outboundOnly": "Outbound only",
  "cannotReceiveCommands": "cannot receive commands",
  "botDMsWorkCrossServerAsLongAsTheBot": "Bot DMs work cross-server as long as the bot and the user share at least one Discord server.",
  "openYourNotificationPreferences": "Open your notification preferences",
  "usersConfigureTheirOwnWebhookURLAndDiscordUserID": "Users configure their own webhook URL and Discord User ID here.",
  "setupInstructions": "Setup Instructions",
  "openDiscordAndGoToTheChannelWhereYouWant": "Open Discord and go to the channel where you want notifications",
  "clickTheGearIconToOpenChannelSettings": "Click the gear icon to open Channel Settings",
  "goToIntegrationsWebhooksNewWebhook": "Go to Integrations > Webhooks > New Webhook",
  "copyTheWebhookURL": "Copy the webhook URL",
  "enableTheDiscordChannelToggleAndSelectWhichEventsTo": "Enable the Discord channel toggle and select which events to receive",
  "testWebhook": "Test Webhook",
  "pasteAnyDiscordWebhookURLToVerifyItReceivesMessages": "Paste any Discord webhook URL to verify it receives messages correctly.",
  "sendTest": "Send Test",
  "comingSoon": "Coming Soon",
  "e164Format1234567890": "E.164 format: +1234567890",
  "invalidAccountNumber": "Invalid account number",
  "invalidRecipient": "Invalid recipient",
  "signalSettingsSaved": "Signal settings saved",
  "signalConfiguration": "Signal Configuration",
  "configureSignalCliForOutboundMessageDelivery": "Configure signal-cli for outbound message delivery.",
  "enableSignalNotifications": "Enable Signal notifications",
  "whenEnabledSignalWillBeAvailableAsANotificationDelivery": "When enabled, Signal will be available as a notification delivery channel.",
  "signalCliPath": "signal-cli Path",
  "pathToTheSignalCliBinary": "Path to the signal-cli binary.",
  "dataDirectory": "Data Directory",
  "leaveEmptyForDefault": "Leave empty for default.",
  "accountNumber": "Account Number",
  "phoneNumberIsEncryptedAtRest": "Phone number is encrypted at rest.",
  "changeAccountNumber": "Change account number",
  "cancel": "Cancel",
  "senderDisplayName": "Sender Display Name",
  "nameShownToRecipientsInSignalMessages": "Name shown to recipients in Signal messages.",
  "defaultRecipients": "Default Recipients",
  "onePhoneNumberPerLineTheseRecipientsReceiveNotificationsWhen": "One phone number per line. These recipients receive notifications when no specific user preference is set.",
  "phoneNumbersAreEncryptedAtRestOnePerLine": "Phone numbers are encrypted at rest. One per line.",
  "changeRecipients": "Change recipients",
  "saveChanges": "Save Changes",
  "idle": "Idle",
  "confirming": "Confirming",
  "running": "Running",
  "completed": "Completed",
  "failed": "Failed",
  "failedToStartInstallation": "Failed to start installation",
  "systemResponse": "System Response",
  "closeDialog": "Close dialog",
  "thisWillDownloadAndInstallTheLatestVersionOfSignal": "This will download and install the latest version of signal-cli on the server.",
  "downloadsOfficialSignalCliReleaseFromGitHub": "Downloads official signal-cli release from GitHub",
  "installsRequiredJavaRuntimeIfNotPresent": "Installs required Java runtime if not present",
  "createsDataDirectoryWithSecurePermissions0700": "Creates data directory with secure permissions (0700)",
  "symlinksToUsrLocalBinSignalCli": "Symlinks to /usr/local/bin/signal-cli",
  "installSignalCli": "Install signal-cli",
  "thisWillRemoveSignalCliFromTheServer": "This will remove signal-cli from the server.",
  "removesSignalCliBinaryAndSymlink": "Removes signal-cli binary and symlink",
  "removesExtractedFilesFromOpt": "Removes extracted files from /opt",
  "dataDirectoryAndPrivateKeysArePreserved": "Data directory and private keys are preserved",
  "removeSignalCli": "Remove signal-cli",
  "signalCliRemovedSuccessfully": "signal-cli removed successfully.",
  "signalCliInstalledSuccessfully": "signal-cli installed successfully.",
  "close": "Close",
  "receiveCompleted": "Receive completed",
  "receiveFailed": "Receive failed",
  "loadingSignalSettings": "Loading Signal settings...",
  "notInstalled": "Not Installed",
  "notLinked": "Not Linked",
  "updateAvailable": "Update Available",
  "checkingStatus": "Checking status...",
  "installed": "Installed",
  "accountLinked": "Account Linked",
  "lastError": "Last error:",
  "refreshStatus": "Refresh Status",
  "receiveMessages": "Receive Messages",
  "reinstall": "Reinstall",
  "remove": "Remove",
  "registerAccount": "Register account:",
  "linkDevice": "Link Device",
  "registerNumber": "Register Number",
  "unableToCheckSignalCliStatusSaveSettingsAndTry": "Unable to check signal-cli status. Save settings and try again.",
  "sendNotificationsViaSignalMessenger": "Send notifications via Signal messenger.",
  "ready": "Ready",
  "linking": "Linking",
  "awaitingScan": "Awaiting Scan",
  "phoneInput": "Phone Input",
  "captchaRequired": "Captcha Required",
  "verifying": "Verifying",
  "failedToStartLinkProcess": "Failed to start link process",
  "streamConnectionLostPollingForStatus": "Stream connection lost. Polling for status...",
  "networkError": "Network error",
  "captchaRequired2": "Captcha required",
  "registrationFailed": "Registration failed",
  "verificationFailed": "Verification failed",
  "linkSignalCliAsASecondaryDevice": "Link signal-cli as a secondary device",
  "registerANewPhoneNumber": "Register a new phone number",
  "thisWillLinkSignalCliAsASecondaryDeviceTo": "This will link signal-cli as a secondary device to your existing Signal account.",
  "youMustHaveSignalInstalledOnYourPhone": "You must have Signal installed on your phone",
  "aQRCodeWillAppearScanItWithSignalSettings": "A QR code will appear — scan it with Signal > Settings > Linked Devices",
  "onceScannedSignalCliCanSendMessagesOnBehalfOf": "Once scanned, signal-cli can send messages on behalf of your account",
  "startLinking": "Start Linking",
  "signalLinkQRCode": "Signal link QR code",
  "scanThisQRCodeWithSignal": "Scan this QR code with Signal",
  "openSignalOnYourPhoneSettingsLinkedDevicesLinkNew": "Open Signal on your phone → Settings → Linked Devices → Link New Device",
  "waitingForScan": "Waiting for scan...",
  "noWrap": "No Wrap",
  "copy": "Copy",
  "scrollToBottom": "Scroll to bottom",
  "startingLinkProcess": "Starting link process...",
  "phoneNumber": "Phone Number",
  "receiveVerificationViaPhoneCall": "Receive verification via phone call",
  "useThisIfYourNumberIsOnAnESIMEmulator": "Use this if your number is on an eSIM emulator or can't receive SMS.",
  "callWithVerificationCode": "Call with Verification Code",
  "sendVerificationSMS": "Send Verification SMS",
  "signalRequiresACaptchaToContinueRegistration": "Signal requires a captcha to continue registration.",
  "howToGetTheCaptchaToken": "How to get the captcha token:",
  "solveTheCaptchaChallenge": "Solve the captcha challenge",
  "anOpenSignalLinkWillAppearOnThePageAfter": "An \"Open Signal\" link will appear on the page after a moment",
  "copyLinkAddress": "Copy Link Address",
  "captchaToken": "Captcha Token",
  "submitCaptcha": "Submit Captcha",
  "verificationCode": "Verification Code",
  "48DigitPIN": "4-8 digit PIN",
  "ifYouHaveASignalRegistrationPINEnterItHere": "If you have a Signal registration PIN, enter it here.",
  "verify": "Verify",
  "accountRegisteredSuccessfully": "Account registered successfully.",
  "registrationFailed2": "Registration failed.",
  "testMessage": "Test Message",
  "sendATestMessageToVerifyYourSignalConfiguration": "Send a test message to verify your Signal configuration.",
  "sendTestMessage": "Send Test Message",
  "enableSignalNotificationsAboveToSendATestMessage": "Enable Signal notifications above to send a test message.",
  "noChangelogAvailableForThisRelease": "No changelog available for this release.",
  "viewOnGitHub": "View on GitHub",
  "confirmRequested": "Confirm requested",
  "dryRun": "Dry run",
  "confirmRejected": "Confirm rejected",
  "when": "When",
  "invoker": "Invoker",
  "action2": "Action",
  "result": "Result",
  "info": "Info",
  "warning": "Warning",
  "error": "Error",
  "details": "Details",
  "failedToLoadCommandAuditLog": "Failed to load command audit log.",
  "thisPermanentlyRemovesTheSelectedCommandActivityRecords": "This permanently removes the selected command activity records.",
  "failedToDeleteEvents": "Failed to delete events.",
  "deleteEvent": "Delete event?",
  "thisPermanentlyRemovesThisCommandActivityRecord": "This permanently removes this command activity record.",
  "purgeAllCommandActivity": "Purge all command activity?",
  "thisPermanentlyDeletesALLCommandEventsThisActionCannotBe": "This permanently deletes ALL command events. This action cannot be undone.",
  "purgeAll": "Purge all",
  "commandActivity": "Command Activity",
  "delete": "Delete",
  "searchCommandActivity": "Search command activity...",
  "noCommandActivityHasBeenRecordedYet": "No command activity has been recorded yet.",
  "deleteEvent2": "Delete event",
  "channelInbound": "Channel & inbound",
  "qBxBotConnection": "QBxBot connection",
  "commandCatalog": "Command catalog",
  "commandInsights": "Command insights",
  "commandActivity2": "Command activity",
  "retry": "Retry",
  "commandChannel": "Command Channel",
  "letAuthorizedUsersOperateThisInstallOverALinkedChat": "Let authorized users operate this install over a linked chat channel (QBxBot).",
  "inboundCommands": "Inbound commands",
  "commandsAreAcceptedFromVerifiedOptedInUsersTurnOff": "Commands are accepted from verified, opted-in users. Turn off to halt all inbound commands install-wide.",
  "offByDefaultWhileDisabledNoInboundCommandIsExecuted": "Off by default. While disabled, no inbound command is executed regardless of per-user settings.",
  "commandChannelEnabled": "Command channel enabled",
  "commandChannelDisabled": "Command channel disabled",
  "enableCommandChannel": "Enable command channel",
  "dryRunMode": "Dry-run mode",
  "parseAndAuthorizeCommandsButSkipExecutionUsefulForTesting": "Parse and authorize commands but skip execution. Useful for testing exposure and roles safely.",
  "discordInbound": "Discord inbound",
  "listenForCommandsSentToThisInstallSQBxBotOver": "Listen for commands sent to this install's QBxBot over Discord.",
  "signalInbound": "Signal inbound",
  "listenForCommandsOverSignalRequiresSignalCliToBe": "Listen for commands over Signal (requires signal-cli to be configured).",
  "qBxBotConnection2": "QBxBot Connection",
  "commandsArriveThroughThisInstallSOwnDiscordBotSet": "Commands arrive through this install's own Discord bot. Set the bot token in channel settings, then enable inbound here.",
  "channelSettings": "channel settings",
  "commandCatalog2": "Command Catalog",
  "chooseWhichCommandsAreAvailableOnThisInstallEachCommand": "Choose which commands are available on this install. Each command enforces its own role and operation type.",
  "commandSections": "Command sections",
  "24h": "24h",
  "7d": "7d",
  "30d": "30d",
  "executed": "Executed",
  "denied": "Denied",
  "errors": "Errors",
  "noCommandActivityInThisWindow": "No command activity in this window.",
  "commandVolumeOverTime": "Command volume over time",
  "noData": "No data.",
  "other": "Other",
  "noOutcomesRecorded": "No outcomes recorded.",
  "outcomeSplit": "Outcome split",
  "metricsTimeRange": "Metrics time range",
  "commandInsights2": "Command Insights",
  "atAGlanceSummaryOfCommandActivityOverTheSelected": "At-a-glance summary of command activity over the selected window.",
  "noCommandActivityRecordedInThisWindow": "No command activity recorded in this window.",
  "commands": "Commands",
  "successRate": "Success rate",
  "avgTime": "Avg time",
  "p95Time": "p95 time",
  "volumeOverTime": "Volume over time",
  "outcomes": "Outcomes",
  "topCommands": "Top commands",
  "noVerbsRecorded": "No verbs recorded.",
  "mostActiveUsers": "Most active users",
  "noInvokersRecorded": "No invokers recorded.",
  "topTargetedApps": "Top targeted apps",
  "noAppTargetedCommands": "No app-targeted commands.",
  "channels": "Channels",
  "noChannelData": "No channel data.",
  "enterAValidNumberInE164FormatEG": "Enter a valid number in E.164 format (e.g. +12025550123).",
  "signalRequiresACaptchaToContinue": "Signal requires a captcha to continue.",
  "enterThe6DigitCodeSentBySMS": "Enter the 6-digit code sent by SMS.",
  "signalNumberVerified": "Signal number verified",
  "verificationFailed2": "Verification failed.",
  "confirmTheBoundSignalNumberInE164FormatTo": "Confirm the bound Signal number in E.164 format to arm.",
  "signalInboundArmed": "Signal inbound armed",
  "enableTheCommandChannelMasterToggleFirstThenArmSignal": "Enable the command channel master toggle first, then arm Signal.",
  "couldNotArmSignal": "Could not arm Signal.",
  "signalInboundDisarmed": "Signal inbound disarmed",
  "couldNotDisarmSignal": "Could not disarm Signal.",
  "signalCommandChannel": "Signal Command Channel",
  "bindThisInstallSSignalNumberAndArmTheInbound": "Bind this install's Signal number and arm the inbound listener.",
  "bindThisInstallSSignalNumberThenArmTheInbound": "Bind this install's Signal number, then arm the inbound listener to accept commands over Signal.",
  "signalNumber": "Signal number",
  "notBound": "Not bound",
  "registerThisInstallSSignalNumberBelowToEnableInbound": "Register this install's Signal number below to enable inbound commands over Signal.",
  "theInboundDaemonIsListeningCommandsFromVerifiedOptedIn": "The inbound daemon is listening. Commands from verified, opted-in users are accepted.",
  "numberIsBoundButTheListenerIsOffArmIt": "Number is bound but the listener is off. Arm it to accept inbound commands over Signal.",
  "disarm": "Disarm",
  "arm": "Arm",
  "enableTheCommandChannelMasterToggleAtTheTopOf": "Enable the command channel master toggle at the top of this tab before arming Signal — arming is blocked while the master is off.",
  "confirmSignalNumberToArm": "Confirm Signal number to arm",
  "reEnterTheBoundNumberInE164FormatTo": "Re-enter the bound number in E.164 format to start the inbound listener.",
  "armSignalInbound": "Arm Signal inbound",
  "reBindNumber": "Re-bind number",
  "bindNumber": "Bind number",
  "startOver": "Start over",
  "theInstallSOwnSignalNumberInE164Format": "The install's own Signal number in E.164 format. A verification SMS is sent to it.",
  "signalRequiresACaptchaToGetTheToken": "Signal requires a captcha. To get the token:",
  "dismissAnyOpenSignalPromptThenRightClickTheOpen": "Dismiss any \"Open Signal\" prompt, then right-click the \"Open Signal\" link and copy the address.",
  "captchaToken2": "Captcha token",
  "verificationCode2": "Verification code",
  "enterThe6DigitCodeSignalSentBySMSTo": "Enter the 6-digit code Signal sent by SMS to the number above.",
  "verifyNumber": "Verify number",
  "submitCaptcha2": "Submit captcha",
  "sendVerificationSMS2": "Send verification SMS",
  "failedToLoadCommandChannelSettings": "Failed to load command channel settings.",
  "failedToUpdateSettings": "Failed to update settings.",
  "failedToUpdateExposure": "Failed to update exposure.",
  "failedToLoadCommandMetrics": "Failed to load command metrics.",
  "failedToLoadSignalStatus": "Failed to load Signal status.",
  "networkError2": "Network error.",
  "failedToLoadNotificationTemplates": "Failed to load notification templates",
  "failedToFetchTemplate": "Failed to fetch template",
  "failedToUpdateTemplate": "Failed to update template",
  "youDonTHavePermissionToViewDiscordSettings": "You don't have permission to view Discord settings.",
  "failedToLoadDiscordStatus": "Failed to load Discord status",
  "failedToUpdateDiscordSettings": "Failed to update Discord settings",
  "failedToSendTest": "Failed to send test",
  "failedToSendTestMessage": "Failed to send test message",
  "failedToSaveBotSettings": "Failed to save bot settings",
  "failedToVerifyBotToken": "Failed to verify bot token",
  "youDonTHavePermissionToViewSignalSettings": "You don't have permission to view Signal settings.",
  "failedToLoadSignalSettings": "Failed to load Signal settings",
  "failedToUpdateSignalSettings": "Failed to update Signal settings",
  "failedToReceiveMessages": "Failed to receive messages",
  "compose": "Compose",
  "history": "History",
  "templates": "Templates",
  "notificationSettings": "Notification Settings",
  "sendNotificationsToUsersAndManageNotificationDelivery": "Send notifications to users and manage notification delivery.",
  "writeYourContentHere": "Write your content here...",
  "bold": "Bold",
  "italic": "Italic",
  "heading": "Heading",
  "link": "Link",
  "list": "List",
  "quote": "Quote",
  "code": "Code",
  "insertImageFromAssetManagementCenter": "Insert image from Asset Management Center",
  "insertImage": "Insert image",
  "write": "Write",
  "nothingToPreview": "Nothing to preview",
  "selectAsset": "Select Asset",
  "browse": "Browse",
  "upload": "Upload",
  "searchAssets": "Search assets...",
  "noAssetsFound": "No assets found",
  "uploadNewAsset": "Upload new asset",
  "selected2": "Selected",
  "insert": "Insert",
  "storageLocation": "Storage location",
  "personalHome": "Personal (home)",
  "storedInTheSharedSystemAssetStore": "Stored in the shared system asset store.",
  "storedInYourHomeDirectorySFTPReachableCountsAgainstYour": "Stored in your home directory (SFTP-reachable, counts against your quota).",
  "dropFilesHere": "Drop files here",
  "dragAndDropFilesHere": "Drag and drop files here",
  "orClickToBrowse": "or click to browse",
  "noSizeLimit": "No size limit",
  "clearCompleted": "Clear completed",
  "failedToFetchAssets": "Failed to fetch assets",
  "addedToTheStorageQueue": "Added to the storage queue.",
  "failedToUploadAsset": "Failed to upload asset",
  "assetUploadedSuccessfully": "Asset uploaded successfully",
  "failedToUpdateAsset": "Failed to update asset",
  "assetUpdatedSuccessfully": "Asset updated successfully",
  "failedToDeleteAsset": "Failed to delete asset",
  "assetDeletedSuccessfully": "Asset deleted successfully",
  "deletedCount": "Deleted {{count}} notifications",
  "deletedCount_one": "Deleted {{count}} notification",
  "deletedCount_other": "Deleted {{count}} notifications",
  "deletedCount_many": "Deleted {{count}} notifications",
  "deleteAllCount": "Permanently delete all {{count}} notifications? This cannot be undone.",
  "deleteAllCount_one": "Permanently delete all {{count}} notification? This cannot be undone.",
  "deleteAllCount_other": "Permanently delete all {{count}} notifications? This cannot be undone.",
  "deleteAllCount_many": "Permanently delete all {{count}} notifications? This cannot be undone.",
  "deleteSelectedCount": "Permanently delete {{count}} notifications? This cannot be undone.",
  "deleteSelectedCount_one": "Permanently delete {{count}} notification? This cannot be undone.",
  "deleteSelectedCount_other": "Permanently delete {{count}} notifications? This cannot be undone.",
  "deleteSelectedCount_many": "Permanently delete {{count}} notifications? This cannot be undone.",
  "historyCount": "{{count}} notifications sent",
  "historyCount_one": "{{count}} notification sent",
  "historyCount_other": "{{count}} notifications sent",
  "historyCount_many": "{{count}} notifications sent",
  "sendCount": "Sent to {{count}} users.",
  "sendCount_one": "Sent to {{count}} user.",
  "sendCount_other": "Sent to {{count}} users.",
  "sendCount_many": "Sent to {{count}} users.",
  "sendPreview": "Will be sent to {{count}} users{{names}}",
  "sendPreview_one": "Will be sent to {{count}} user{{names}}",
  "sendPreview_other": "Will be sent to {{count}} users{{names}}",
  "sendPreview_many": "Will be sent to {{count}} users{{names}}",
  "templateCount": "{{count}} templates — customize in-app notification wording",
  "templateCount_one": "{{count}} template — customize in-app notification wording",
  "templateCount_other": "{{count}} templates — customize in-app notification wording",
  "templateCount_many": "{{count}} templates — customize in-app notification wording",
  "deleteEventCount": "Delete {{count}} events?",
  "deleteEventCount_one": "Delete {{count}} event?",
  "deleteEventCount_other": "Delete {{count}} events?",
  "deleteEventCount_many": "Delete {{count}} events?",
  "eventCount": "{{count}} command events recorded",
  "eventCount_one": "{{count}} command event recorded",
  "eventCount_other": "{{count}} command events recorded",
  "eventCount_many": "{{count}} command events recorded",
  "commandCount": "{{time}}: {{count}} commands",
  "commandCount_one": "{{time}}: {{count}} command",
  "commandCount_other": "{{time}}: {{count}} commands",
  "commandCount_many": "{{time}}: {{count}} commands",
  "linesCount": "{{count}} lines",
  "linesCount_one": "{{count}} line",
  "linesCount_other": "{{count}} lines",
  "linesCount_many": "{{count}} lines",
  "deletedAll": "Deleted all notifications",
  "selectNotification": "Select notification {{id}}",
  "deleteFor": "Permanently delete this notification to {{username}}? This cannot be undone.",
  "selectedCount": "{{count}} selected",
  "recipientNamed": "To: {{username}}",
  "collapse": "Collapse",
  "expand": "Expand",
  "bodyOptional": "Body (optional, Markdown supported)",
  "moreCount": "+{{count}} more",
  "allUsersCount": "All users ({{count}})",
  "noUsersFor": "No users found for “{{query}}”",
  "removeUser": "Remove {{username}}",
  "configuredCount": "{{count}} configured",
  "savedValue": "Saved: {{value}}",
  "botVerifiedNamed": "Bot token verified{{name}}",
  "providerUnavailable": "{{name}} integration is not yet available. Check back in a future release.",
  "invalidRecipientFormat": "“{{recipient}}” does not look like a valid phone number. E.164 format: +1234567890",
  "updateVersion": "Update to v{{version}}",
  "updateSignalVersion": "Update signal-cli to v{{version}}",
  "currentVersion": "Currently: v{{version}}",
  "releasedDate": "Released {{date}}",
  "updateSignalDescription": "This will update signal-cli to v{{version}} on the server.",
  "signalUpdated": "signal-cli updated to v{{version}} successfully.",
  "removalFailed": "Removal failed.",
  "updateFailed": "Update failed.",
  "installationFailed": "Installation failed.",
  "removalFailedCode": "Removal failed (exit code {{code}}).",
  "updateFailedCode": "Update failed (exit code {{code}}).",
  "installationFailedCode": "Installation failed (exit code {{code}}).",
  "accountRegistered": "Account {{account}} registered successfully.",
  "verbExposed": "{{verb}} exposed",
  "verbHidden": "{{verb}} hidden",
  "exposeVerb": "Expose {{verb}}",
  "manageOnDashboard": "Manage {{title}} on the dashboard",
  "executedCount": "{{count}} executed",
  "timedCount": "{{count}} timed",
  "deniedErrors": "{{denied}} denied · {{errors}} errors",
  "maximumTime": "max {{duration}}",
  "metricPair": "{{label}}: {{count}}",
  "invalidFileType": "Invalid file type: {{type}}",
  "fileTooLarge": "File too large: {{size}} (max {{maximum}})",
  "maximumSize": "Max {{size}}",
  "uploadsCount": "Uploads ({{count}})",
  "fetchAssetsStatus": "Failed to fetch assets: {{status}}",
  "unknown": "unknown",
  "blocked": "Blocked",
  "botActive": "Bot active",
  "botDisabled": "Bot disabled",
  "active": "Active",
  "verifyingNow": "Verifying...",
  "registerPhoneSms": "Register a dedicated phone number with signal-cli. You will receive an SMS with a verification code.",
  "registerPhoneVoice": "Register a dedicated phone number with signal-cli. You will receive a phone call with a verification code.",
  "captchaVoice": "Signal requires a captcha to continue registration. Once submitted, you will receive a phone call with the verification code.",
  "openCaptcha": "Open {{link}} in any browser.",
  "openCaptchaSolve": "Open {{link}} in any browser and solve the challenge.",
  "cancelSignalPrompt": "A dialog may ask to “Open Signal” — click {{cancel}} or dismiss it.",
  "copyCaptchaLink": "Right-click that link and select {{copy}}.",
  "pasteCaptchaUrl": "Paste the {{scheme}} URL below.",
  "pasteCaptchaToken": "Paste the {{scheme}} token below.",
  "verifyCodeSms": "Enter the verification code sent via SMS to {{phone}}.",
  "verifyCodeVoice": "Enter the verification code from the phone call to {{phone}}.",
  "optionalSignalPin": "Signal PIN (optional)",
  "discordTokenHelp": "Configure a Discord bot token to send private DMs to users and to receive their commands. Users enter their Discord User ID in {{profile}} to opt in. The bot must share at least one server with each user.",
  "discordBidirectionalHelp": "The bidirectional channel. It sends users personal DMs {{and}} receives their commands. This is what powers inbound commands and bot-DM alerts.",
  "discordWebhookHelp": "Posts alerts into a Discord channel. Each user supplies their own webhook URL. A webhook {{cannot}} — it only sends.",
  "pasteDiscordWebhook": "Paste it in {{profile}} > Discord Webhook URL.",
  "botInboundHelp": "The Discord bot token is configured under {{settings}}. Inbound commands use the same bot — enable Discord inbound above once the token is set.",
  "fileSupport": "Images, PDF, video, audio, CSV, text & Office docs · {{limit}}",
  "webhookUserCount": "{{count}} webhook users",
  "webhookUserCount_one": "{{count}} webhook user",
  "webhookUserCount_other": "{{count}} webhook users",
  "webhookUserCount_many": "{{count}} webhook users",
  "linked": "Linked",
  "install": "Install",
  "listening": "Listening",
  "off": "Off",
  "wrap": "Wrap",
  "receivingNow": "Receiving...",
  "signalRemoval": "signal-cli Removal",
  "signalInstallation": "signal-cli Installation",
  "critical": "Critical",
  "applications": "Applications",
  "sessions": "Sessions",
  "armed": "Armed",
  "disarmed": "Disarmed",
  "uploadingNow": "Uploading...",
  "done": "Done",
  "quickBoxDashboard": "QuickBox Dashboard"
} as const;
